import { render, staticRenderFns } from "./VlFilterTransition.vue?vue&type=template&id=0686dcf8&"
import script from "./VlFilterTransition.vue?vue&type=script&lang=js&"
export * from "./VlFilterTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports